import React from 'react';
import Grid from '@mui/material/Grid2';
import FormLabel from '@mui/material/FormLabel';
import { GridDateTimePicker } from './shared';
import FormBlock from './FormBlock';

function InlineTextField(props) {
  return (
    <FormBlock variant="contained">
      <Grid size={{ xs: 6 }}>
        <FormLabel>{props.label}</FormLabel>
      </Grid>
      <GridDateTimePicker
        xs={props.xs || 6}
        name={props.name}
        format={props.format}
      />
    </FormBlock>
  );
}

export default InlineTextField;
